import {
  container,
  primaryColor,
  secondaryColor,
  title,
} from "../../nextjs-material-kit.js";

const landingPageStyle = (theme) => ({
  homeSearchButton: {
    borderRadius: "6px",
    width: "15%",
    height: "34.25px",
    fontSize: "18px",
    marginTop: "0",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 700,
    textTransform: "none",
    backgroundColor: "#095a70",
    marginBottom: "0px",
    marginLeft: "25px",
    lineHeight: "16px",
    display: "flex",
    boxShadow: "none",
    padding: "8px 30px",
    "&:hover": {
      backgroundColor: "#00acc1",
    },
  },
  inputStyle: {
    margin: "0 !important",
  },
  whereField: {
    width: "90%",
    margin: "0 19px",
    paddingTop: "0 !important",
    marginBottom: "20px !important",
    background: "white",
    "@media (max-width: 768px)": {
      padding: "0",
      margin: 0,
    },
    "& .MuiInput-input": {
      padding: "7px 4px",
    },
    "&:before": {
      display: "none",
    },
  },
  container: {
    zIndex: "12",
    color: "#ffffff",
    ...container(theme),
  },
  relative: {
    position: "relative",
  },
  welcomeImg: {
    position: "absolute",
    top: "-52px",
    right: "20px",
  },
  max_width: {
    width: "30%",
    maxWidth: "80%",
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px !important",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    fontSize: "5.5em",
    left: "50%",
    transform: "translateX(-50%)",
    textAlign: "center",
  },
  parrallexTitle: {
    marginTop: "80px",
  },
  smallTitle: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "13px",
    marginBottom: "5px",
    minHeight: "32px",
    color: "#005a70",
    textDecoration: "none",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    fontSize: "60px",
    textAlign: "left",
  },
  search_section: {
    paddingTop: "20px",
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0",
  },
  main: {
    ...container(theme),
    position: "relative",
    zIndex: "3",
  },
  bg_colored: {
    backgroundColor: "#eaf6fe",
  },
  darkBlue: {
    backgroundColor: primaryColor,
  },
  lightGreen: {
    backgroundColor: secondaryColor,
    paddingTop: "7px",
    paddingBottom: "8px",
    marginTop: "22px",
  },
  btnSpacing: {
    paddingTop: "7px",
    paddingBottom: "8px",
    marginTop: "24px",
  },
  colored_bg: {
    background: "#eaf6fe",
    padding: "50px 0",
    minHeight: "280px",
  },
  white_bg: {
    background: "#ffffff",
  },
  btnSearch: {
    width: "79%",
    padding: "4px 0 !important",
    marginBottom: "0 !important",
    marginTop: "0",
    "@media (max-width: 768px)": {
      width: "100%",
      margin: "13px 0 !important",
    },
  },
  text: {
    color: "#000",
    fontFamily: "var(--font-brandon-grotesque)",
    fontSize: "18px",
  },
  advert: {
    margin: "40px auto 0",
    width: "100%",
    textAlign: "center",
  },
});

export default landingPageStyle;
